/**
 * @flow
 * @relayHash 3801edba30fb6db3e2de5d8fc06e49b1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type app_viewer$ref = any;
export type app_QueryVariables = {| |};
export type app_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: app_viewer$ref,
  |},
|};
*/


/*
query app_Query {
  viewer {
    ...app_viewer
    id
  }
}

fragment app_viewer on Viewer {
  id
  authentication_info {
    user_pool_id
    client_id
    cognito_domain_url
  }
  business_information {
    ams {
      id
      name
      legal_name
      website
      logo
      emails {
        email
        type
      }
      phone_numbers {
        type
        phone_number
        is_toll_free
      }
      social_media {
        image
        facebook
        twitter
        instagram
        youtube
      }
      opening_hours
      address {
        id
        name
        company
        line_1
        line_2
        city
        postal_code
        subdivision_code
        subdivision_name
        country_code
        country_name
      }
      commercial_details {
        financial_institution {
          id
          name
          company
          line_1
          line_2
          city
          postal_code
          subdivision_code
          subdivision_name
          country_code
          country_name
        }
        bank_accounts {
          currency
          swift_code
          branch_id
          account_number
        }
        gst_number
        pst_number
      }
    }
  }
  cart {
    id
    license_line_items {
      id
      amount
      discount_amount
      track {
        id
        internal_id
        title
        added_to_cart
        slug
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
      }
      license {
        id
        usages {
          id
          license_id
          air_date
          components {
            id
            component_id
            name
            type
          }
        }
      }
    }
    total
  }
  profile {
    id
    user_id
    email
    external_provider
    first_name
    is_new_user
    ga_account_goal_sent
    last_name
    picture
    company_name
    company_size {
      name
      id
    }
    industry {
      name
      id
    }
    job_type {
      name
      id
    }
  }
  latest_exchange_rates {
    id
    from_currency
    to_currency
    rate
    rate_date
  }
  license_components {
    media(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    spot_counts(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    terms(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    broadcast_territories(first: 300) {
      edges {
        node {
          internal_id
          display_order
          name
          is_region
          id
        }
      }
    }
    producer_locations(first: 300) {
      edges {
        node {
          internal_id
          display_order
          name
          is_user_location
          id
        }
      }
    }
    audience_sizes(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    production_budgets(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    episode_budgets(first: 100) {
      edges {
        node {
          internal_id
          display_order
          name
          id
        }
      }
    }
    id
  }
  projects(first: 100, scope: CurrentUser) {
    edges {
      node {
        id
        is_public
        name
        notes
        tracks(first: 100) {
          edges {
            id
            cursor
            node {
              __typename
              id
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        owner {
          id
          first_name
          last_name
          user_id
        }
        users {
          id
          first_name
          last_name
          user_id
          role
        }
        license_params {
          spot_count
          term
          medium
          contextual_param
          contextual_param_type
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  taxonomies(first: 10000000) {
    edges {
      node {
        id
        internal_id
        name
        terms {
          id
          internal_id
          parent_id
          name
          children {
            edges {
              node {
                id
                internal_id
                parent_id
                name
              }
            }
          }
        }
      }
    }
  }
  tempos {
    edges {
      node {
        id
        name
        value
      }
    }
  }
  ...selectedCurrency_viewer
  ...header_viewer
}

fragment selectedCurrency_viewer on Viewer {
  selected_currency
}

fragment header_viewer on Viewer {
  home_page {
    header_posts {
      title
      subtitle
      post_url
      image_url
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 100,
  "type": "Int"
},
v1 = [
  v0
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "display_order",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = [
  v2,
  v3,
  v4,
  v5
],
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 300,
    "type": "Int"
  }
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v10 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
  v5,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  },
  v4,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_name",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_name",
    "args": null,
    "storageKey": null
  }
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v5,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    v9,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "parent_id",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "user_id",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v18 = [
  v4,
  v5
],
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "app_Query",
  "id": null,
  "text": "query app_Query {\n  viewer {\n    ...app_viewer\n    id\n  }\n}\n\nfragment app_viewer on Viewer {\n  id\n  authentication_info {\n    user_pool_id\n    client_id\n    cognito_domain_url\n  }\n  business_information {\n    ams {\n      id\n      name\n      legal_name\n      website\n      logo\n      emails {\n        email\n        type\n      }\n      phone_numbers {\n        type\n        phone_number\n        is_toll_free\n      }\n      social_media {\n        image\n        facebook\n        twitter\n        instagram\n        youtube\n      }\n      opening_hours\n      address {\n        id\n        name\n        company\n        line_1\n        line_2\n        city\n        postal_code\n        subdivision_code\n        subdivision_name\n        country_code\n        country_name\n      }\n      commercial_details {\n        financial_institution {\n          id\n          name\n          company\n          line_1\n          line_2\n          city\n          postal_code\n          subdivision_code\n          subdivision_name\n          country_code\n          country_name\n        }\n        bank_accounts {\n          currency\n          swift_code\n          branch_id\n          account_number\n        }\n        gst_number\n        pst_number\n      }\n    }\n  }\n  cart {\n    id\n    license_line_items {\n      id\n      amount\n      discount_amount\n      track {\n        id\n        internal_id\n        title\n        added_to_cart\n        slug\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n      }\n      license {\n        id\n        usages {\n          id\n          license_id\n          air_date\n          components {\n            id\n            component_id\n            name\n            type\n          }\n        }\n      }\n    }\n    total\n  }\n  profile {\n    id\n    user_id\n    email\n    external_provider\n    first_name\n    is_new_user\n    ga_account_goal_sent\n    last_name\n    picture\n    company_name\n    company_size {\n      name\n      id\n    }\n    industry {\n      name\n      id\n    }\n    job_type {\n      name\n      id\n    }\n  }\n  latest_exchange_rates {\n    id\n    from_currency\n    to_currency\n    rate\n    rate_date\n  }\n  license_components {\n    media(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    spot_counts(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    terms(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    broadcast_territories(first: 300) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          is_region\n          id\n        }\n      }\n    }\n    producer_locations(first: 300) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          is_user_location\n          id\n        }\n      }\n    }\n    audience_sizes(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    production_budgets(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    episode_budgets(first: 100) {\n      edges {\n        node {\n          internal_id\n          display_order\n          name\n          id\n        }\n      }\n    }\n    id\n  }\n  projects(first: 100, scope: CurrentUser) {\n    edges {\n      node {\n        id\n        is_public\n        name\n        notes\n        tracks(first: 100) {\n          edges {\n            id\n            cursor\n            node {\n              __typename\n              id\n            }\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        owner {\n          id\n          first_name\n          last_name\n          user_id\n        }\n        users {\n          id\n          first_name\n          last_name\n          user_id\n          role\n        }\n        license_params {\n          spot_count\n          term\n          medium\n          contextual_param\n          contextual_param_type\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  taxonomies(first: 10000000) {\n    edges {\n      node {\n        id\n        internal_id\n        name\n        terms {\n          id\n          internal_id\n          parent_id\n          name\n          children {\n            edges {\n              node {\n                id\n                internal_id\n                parent_id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  tempos {\n    edges {\n      node {\n        id\n        name\n        value\n      }\n    }\n  }\n  ...selectedCurrency_viewer\n  ...header_viewer\n}\n\nfragment selectedCurrency_viewer on Viewer {\n  selected_currency\n}\n\nfragment header_viewer on Viewer {\n  home_page {\n    header_posts {\n      title\n      subtitle\n      post_url\n      image_url\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "app_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "app_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "app_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "license_components",
            "storageKey": null,
            "args": null,
            "concreteType": "LicenseComponents",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "media",
                "storageKey": "media(first:100)",
                "args": v1,
                "concreteType": "MediumConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediumEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Medium",
                        "plural": false,
                        "selections": v6
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "spot_counts",
                "storageKey": "spot_counts(first:100)",
                "args": v1,
                "concreteType": "SpotCountConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SpotCountEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SpotCount",
                        "plural": false,
                        "selections": v6
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "terms",
                "storageKey": "terms(first:100)",
                "args": v1,
                "concreteType": "TermConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TermEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Term",
                        "plural": false,
                        "selections": v6
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "broadcast_territories",
                "storageKey": "broadcast_territories(first:300)",
                "args": v7,
                "concreteType": "BroadcastTerritoryConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BroadcastTerritoryEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BroadcastTerritory",
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          v4,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "is_region",
                            "args": null,
                            "storageKey": null
                          },
                          v5
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "producer_locations",
                "storageKey": "producer_locations(first:300)",
                "args": v7,
                "concreteType": "ProducerLocationConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProducerLocationEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProducerLocation",
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          v4,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "is_user_location",
                            "args": null,
                            "storageKey": null
                          },
                          v5
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "audience_sizes",
                "storageKey": "audience_sizes(first:100)",
                "args": v1,
                "concreteType": "AudienceSizeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AudienceSizeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AudienceSize",
                        "plural": false,
                        "selections": v6
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "production_budgets",
                "storageKey": "production_budgets(first:100)",
                "args": v1,
                "concreteType": "ProductionBudgetConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProductionBudgetEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProductionBudget",
                        "plural": false,
                        "selections": v6
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "episode_budgets",
                "storageKey": "episode_budgets(first:100)",
                "args": v1,
                "concreteType": "EpisodeBudgetConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EpisodeBudgetEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EpisodeBudget",
                        "plural": false,
                        "selections": v6
                      }
                    ]
                  }
                ]
              },
              v5
            ]
          },
          v5,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "business_information",
            "storageKey": null,
            "args": null,
            "concreteType": "BusinessInformationDirectory",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ams",
                "storageKey": null,
                "args": null,
                "concreteType": "BusinessInformation",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "emails",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BusinessEmail",
                    "plural": true,
                    "selections": [
                      v8,
                      v9
                    ]
                  },
                  v5,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "legal_name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "website",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "logo",
                    "args": null,
                    "storageKey": null
                  },
                  v4,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "phone_numbers",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BusinessPhoneNumber",
                    "plural": true,
                    "selections": [
                      v9,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "phone_number",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "is_toll_free",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "social_media",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BusinessSocialMedia",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "image",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "facebook",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "twitter",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "instagram",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "youtube",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "opening_hours",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": v10
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "commercial_details",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BusinessCommercialDetails",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "financial_institution",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Address",
                        "plural": false,
                        "selections": v10
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bank_accounts",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BusinessBankAccount",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "currency",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "swift_code",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "branch_id",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "account_number",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "gst_number",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "pst_number",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              v5,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "license_line_items",
                "storageKey": null,
                "args": null,
                "concreteType": "LicenseLineItem",
                "plural": true,
                "selections": [
                  v5,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "amount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "discount_amount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "track",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TrackSearchResult",
                    "plural": false,
                    "selections": [
                      v5,
                      v2,
                      v11,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "added_to_cart",
                        "args": null,
                        "storageKey": null
                      },
                      v12,
                      v13,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "artist",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Artist",
                        "plural": false,
                        "selections": [
                          v5,
                          v4,
                          v12,
                          v13
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "terms",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TaxonomyTermConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TaxonomyTermEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TaxonomyTerm",
                                "plural": false,
                                "selections": [
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "is_highlighted",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v4,
                                  v14,
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "taxonomy",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Taxonomy",
                                    "plural": false,
                                    "selections": [
                                      v5,
                                      v2,
                                      v4
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "license",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StandardLicense",
                    "plural": false,
                    "selections": [
                      v5,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "usages",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StandardLicenseUsage",
                        "plural": true,
                        "selections": [
                          v5,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "license_id",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "air_date",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "components",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StandardLicenseUsageComponent",
                            "plural": true,
                            "selections": [
                              v5,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "component_id",
                                "args": null,
                                "storageKey": null
                              },
                              v4,
                              v9
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "ga_account_goal_sent",
                "args": null,
                "storageKey": null
              },
              v5,
              v8,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "external_provider",
                "args": null,
                "storageKey": null
              },
              v15,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_new_user",
                "args": null,
                "storageKey": null
              },
              v16,
              v17,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "picture",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "company_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "company_size",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanySize",
                "plural": false,
                "selections": v18
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "industry",
                "storageKey": null,
                "args": null,
                "concreteType": "Industry",
                "plural": false,
                "selections": v18
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "job_type",
                "storageKey": null,
                "args": null,
                "concreteType": "JobType",
                "plural": false,
                "selections": v18
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "latest_exchange_rates",
            "storageKey": null,
            "args": null,
            "concreteType": "ExchangeRate",
            "plural": true,
            "selections": [
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "from_currency",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "to_currency",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rate_date",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "authentication_info",
            "storageKey": null,
            "args": null,
            "concreteType": "AuthenticationInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "user_pool_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "client_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cognito_domain_url",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "projects",
            "storageKey": "projects(first:100,scope:\"CurrentUser\")",
            "args": [
              v0,
              {
                "kind": "Literal",
                "name": "scope",
                "value": "CurrentUser",
                "type": "QueryScopeEnumType!"
              }
            ],
            "concreteType": "ProjectConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ProjectEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Project",
                    "plural": false,
                    "selections": [
                      v5,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "is_public",
                        "args": null,
                        "storageKey": null
                      },
                      v4,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "notes",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tracks",
                        "storageKey": "tracks(first:100)",
                        "args": v1,
                        "concreteType": "ProjectTrackConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProjectTrackEdge",
                            "plural": true,
                            "selections": [
                              v5,
                              v19,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TrackSearchResult",
                                "plural": false,
                                "selections": [
                                  v20,
                                  v5
                                ]
                              }
                            ]
                          },
                          v21
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "tracks",
                        "args": v1,
                        "handle": "connection",
                        "key": "project_tracks",
                        "filters": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "owner",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProjectUser",
                        "plural": false,
                        "selections": [
                          v5,
                          v15,
                          v17,
                          v16
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "users",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProjectUser",
                        "plural": true,
                        "selections": [
                          v5,
                          v15,
                          v17,
                          v16,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "role",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "license_params",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LicenseUsageParams",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "spot_count",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "term",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "medium",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "contextual_param",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "contextual_param_type",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      v20
                    ]
                  },
                  v19
                ]
              },
              v21
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "projects",
            "args": [
              v0,
              {
                "kind": "Literal",
                "name": "scope",
                "value": "CurrentUser",
                "type": "QueryScopeEnumType!"
              }
            ],
            "handle": "connection",
            "key": "list_projects",
            "filters": []
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "taxonomies",
            "storageKey": "taxonomies(first:10000000)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10000000,
                "type": "Int"
              }
            ],
            "concreteType": "TaxonomyConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Taxonomy",
                    "plural": false,
                    "selections": [
                      v5,
                      v2,
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "terms",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TaxonomyTerm",
                        "plural": true,
                        "selections": [
                          v5,
                          v2,
                          v14,
                          v4,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "children",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TaxonomyTermConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TaxonomyTermEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TaxonomyTerm",
                                    "plural": false,
                                    "selections": [
                                      v5,
                                      v2,
                                      v14,
                                      v4
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tempos",
            "storageKey": null,
            "args": null,
            "concreteType": "TempoConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TempoEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Tempo",
                    "plural": false,
                    "selections": [
                      v5,
                      v4,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "value",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_currency",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "home_page",
            "storageKey": null,
            "args": null,
            "concreteType": "HomePageContent",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "header_posts",
                "storageKey": null,
                "args": null,
                "concreteType": "HomePagePost",
                "plural": true,
                "selections": [
                  v11,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "subtitle",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "post_url",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "image_url",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'c49d8c116c42c2d8f2ace8e018bf4aed';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/app_Query.graphql.js